import navigate from '@/utils/navigate';
import percentage from '@/utils/percentage';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import * as React from 'react';

const Component = props => {
    const { total, unused } = props.data;

    return (
        <Card>
            <CardContent sx={{ height: 260 }}>
                <Typography color="text.secondary" gutterBottom sx={{ fontSize: 14 }}>
                    Tariffs
                </Typography>
                <Typography component="div" variant="h5">
                    Total: {total}
                </Typography>
                <br/>
                <Typography variant="body2">
                    Unused: {unused} ({percentage(unused, total)})
                </Typography>
            </CardContent>
            <CardActions sx={{ height: 20 }}>
                <Button onClick={() => navigate('/tariffs')}>View Tariffs</Button>
            </CardActions>
        </Card>
    );
};

export default Component;
